<template>
  <div class="go-in">
    <div
      class="organizational"
      id="table"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/news/companyNews"
          title="公司新闻"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          font-size: 0.16rem;
        "
      >
        <div
          v-for="(item, index) in pageDataList"
          :key="index"
          style="
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            margin-bottom: 0.1rem;
            width: 100%;
          "
        >
          <!-- 从此处开始遍历新闻 -->
          <div
            style="
              margin-bottom: 0.35rem;
              display: flex;
              width: 100%;
              height: 165px;
            "
            v-if="index == 0"
          >
            <div>
              <img
                style="width: 2.45rem; margin-right: 0.5rem; height: 100%"
                :src="getUrl(getEditorImg(item.txt)[0])"
                v-if="getEditorImg(item.txt)[0]"
                alt=""
              />
            </div>
            <div style="flex: 1">
              <div class="news-content" @click="clickNewsItem(item, index)">
                <p style="font-weight: bold; font-size: 0.25rem">
                  {{ item.title }}
                </p>
                <p style="font-size: 0.15rem">{{ item.createTime }}</p>
                <EllipsisComponent position="end" :rows="2">
                  {{ getPlainTex(item.txt) }}
                </EllipsisComponent>
                <!-- <div class="fold-wrap">
                  {{ getPlainTex(item.txt) }}
                </div> -->
                <!-- <vue-ellipsis
                  :visible-line="3"
                  class="ellipsis"
                  ellipsis-node="...."
                  :text=""
                >
                </vue-ellipsis> -->
              </div>
            </div>
          </div>
          <div class="news-list" @click="clickNewsItem(item, index)" v-else>
            <div>
              <i class="el-icon-document" style="color: #bfbfbf"></i>
              <span
                style="color: #333333; margin-left: 0.03rem; font-size: 0.15rem"
                >{{ item.title }}</span
              >
            </div>
            <span style="font-size: 0.12rem; margin-right: 0.4rem; color: #ccc">
              {{ item.createTime }}
            </span>
          </div>
        </div>
        <div
          style="margin: 0.2rem 0rem; font-size: 0.16rem; align-self: center"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
import { ellipsisComponent } from '@hyjiacan/vue-ellipsis';

export default {
  components: {
    TitleTips,
    EllipsisComponent: ellipsisComponent
  },
  name: 'companyNews',
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      formData: {
        groupType: '102'
      },
      pageDataList: [
        // {
        //   title: "公司党委组织参观红色教育基地主体党日活动",
        //   userName: "1蛋",
        //   updateTime: "2018-01-09 00:00:00",
        //   createTime: "2018-01-09 00:00:00",
        //   id: "121",
        //   liulang: "2001",
        //   describe: "新产品贡献奖",
        //   txt: "<img src='https://d1icd6shlvmxi6.cloudfront.net/gsc/HWHPSF/1f/d9/45/1fd9450986d643048083d90c034c0e7c/images/%E6%96%B0%E9%97%BB%E4%B8%AD%E5%BF%83-%E5%85%AC%E5%8F%B8%E6%96%B0%E9%97%BB/u8.png?pageId=ff450aca-0eef-47d4-aa95-d73190c62bee'></img>\n<p>发达扩大市场的售楼处反对斯大林山东房产税的VS的v谁对谁错打发士大夫士大夫发射点发生四点士大夫发射点法大师可适当放宽第三方犯得上士大夫孙菲菲的随风倒士大夫士大夫发射点发射点犯得上士大夫士大夫士大夫电风扇犯得上是犯得上士大夫犯得上士大夫士大夫士大夫的范德萨范德萨士大夫士大夫士大夫士大夫犯得上士大夫士大夫士大夫士大夫胜多负少士大夫犯得上士大夫士大夫士大夫犯得上士大夫士大夫士大夫撒旦傅撒旦发射点大发生发撒的撒旦范德萨士大夫士大夫,</p>\n<p>发达舒服,</p>\n<p>发达说过的萨法</p>\n<p><strong>测试测试</strong></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
        // },
      ],
      routerList: [],
      pageLoading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getUrl(str) {
      const res = getFileUrl(str);
      return res;
    },
    getData() {
      this.pageLoading = true;
      http
        .post('/reception/news/getNewsPage', {
          ...this.formData,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          title: ''
        })
        .then(res => {
          this.pageDataList = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    getEditorImg(str) {
      var data = [];
      str.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/,
        function (match, capture) {
          data.push(capture);
        }
      );
      return data;
    },
    convertIdeogramToNormalCharacter(val) {
      const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
      return val.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
      });
    },
    getPlainTex(richCont) {
      let value = richCont;
      if (richCont) {
        // 方法一：
        value = value.replace(/\s*/g, ''); //去掉空格
        value = value.replace(/<[^>]+>/g, ''); //去掉所有的html标记
        value = value.replace(/↵/g, ''); //去掉所有的↵符号
        value = value.replace(/[\r\n]/g, ''); //去掉回车换行
        value = value.replace(/&nbsp;/g, ''); //去掉空格
        value = this.convertIdeogramToNormalCharacter(value);
        return value;
      } else {
        return null;
      }
    },
    clickNewsItem(item) {
      // let params = {
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      //   currntIndex: index,
      //   currentPageDataList: this.pageDataList,
      //   groupType:'102'
      // };
      this.$router.push({ path: `/news/newsDetail/${item.id}` });
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.fold-wrap {
  font-size: 16px;
  height: 46px;
  overflow: hidden;
  position: relative;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // &:after {
  //   z-index: 3;
  //   content: '...';
  //   position: absolute;
  //   bottom: 2px;
  //   right: 5px;
  //   width: 10px;
  //   background: rgba(242, 242, 242, 0.4352941176);
  //   background: linear-gradient(
  //     to right,
  //     rgba(242, 242, 242, 1),
  //     rgba(242, 242, 242, 0.4352941176) 45%
  //   );
  // }
}
.ellipsis {
  ::v-deep .vue-ellipsis-js-content {
    font-size: 16px !important;
  }
}
.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .news-content {
      box-sizing: border-box;
      cursor: pointer;
      padding: 0.1rem;
      background: #f2f2f26f;
      // width: 8.88rem;
      height: 100%;
      p:nth-child(1) {
        color: #333;
        font-size: 0.18rem;
        font-weight: 600;
      }
      p:nth-child(2) {
        margin: 0.05rem 0rem;
        color: #333;
        font-size: 0.14rem;
      }
      p:nth-child(3) {
        margin: 0.05rem 0rem;
        font-size: 0.13rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }
    .news-list {
      width: 100%;
      height: 0.49rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid #bfbfbf;
    }
  }
}
</style>
